import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTable,
  ConfigurationPageType,
  ConfigurationTableFilterType,
  tableTabAt,
} from "../interfaces";
import { SURQUAL_PROPERTY_PAGE } from "./SURQUAL_PROPERTY";

export const MAPPING_PROPERTY_PAGE: ConfigurationPageTable = {
  type: ConfigurationPageType.TABLE,
  // URL de la page
  // Nom de la page à utiliser pour la traduction
  label: "PROPERTY",
  menuLabel: "PROPERTY",
  pageLabel: "PROPERTY_TITLE_MAPPING",
  name: "mapping_property",
  path: "properties",
  description: "CONF_DESC_MAPPING_PROPERTY",
  model: {
    entityName: "datafeed",
    label: "PROPERTY",
    path: "/api/mapping/properties",
    bulkPath: "/api/mapping/properties/bulk-updates",
    name: "mapping_property",
    attributes: [
      {
        key: "datafeed",
        order: 1,
        label: "DATA_FEED_CODE",
        visible: true,
      },
      {
        key: "connector",
        order: 2,
        label: "CONNECTOR_CODE",
        visible: true,
      },
      {
        key: "nb_uh_r12",
        className: "progressOcc",
        order: 3,
        label: "OCC_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS,
        visible: true,
      },
      {
        key: "turnover_r12",
        className: "progressCA",
        order: 4,
        label: "CA_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "pm_r12",
        className: "progressPM",
        order: 5,
        label: "PM_SOLD",
        sortingOrder: ["desc", "asc", null],
        type: FormatType.PROGRESS_CURRENCY,
        visible: true,
      },
      {
        key: "description",
        order: 6,
        label: "DATA_FEED_DESCRIPTION",
        visible: true,
      },
      {
        key: "property.hebergement_nom_court",
        order: 7,
        label: "PROPERTY",
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Unmapped,
        api: "/api/mapping/properties/?is_unmapped=1",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/mapping/properties/connectors/",
        apiParams: {
          page_size: 100,
          ordering: "connector",
        },
        key: "id",
        labelKey: "id",
        label: "CONNECTOR_CODE",
        lookup: "connector",
        allowEmpty: true,
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/mapping/properties/export" },
    import: { path: "/api/mapping/properties/presign-url" },
  },
  // Options pour le tableau de la page
  options: {
    formFields: [
      {
        key: "datafeed",
        label: "DATA_FEED_CODE",
        type: ConfigurationFormType.Input,
      },
      {
        key: "description",
        label: "DATA_FEED_DESCRIPTION",
        type: ConfigurationFormType.Input,
      },
      {
        key: "connector",
        label: "CONNECTOR_CODE",
        type: ConfigurationFormType.Input,
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
        subCreationForm: tableTabAt(SURQUAL_PROPERTY_PAGE.tabs, 0),
      },
    ],
    copyable: false,
    creatable: false,
    deletable: false,
    editable: true,
    editOptions: [
      {
        key: "datafeed",
        flex: "100%",
        readonly: true,
      },
      {
        key: "connector",
        flex: "100%",
        readonly: true,
      },
      {
        key: "description",
        flex: "100%",
        readonly: true,
      },
      {
        key: "property",
        flex: "100%",
      },
    ],
    editSelectedOptions: [
      {
        key: "property",
        flex: "100%",
      },
    ],
  },
};
